import type { OrgBranding } from "@/types/api";
import { http } from "./http";

/**
 * Partner branding, resolved from the dashboard's own hostname BEFORE anyone
 * signs in — the sign-in screen has no session, so this cannot come from
 * /api/org/me.
 *
 * Hostname selects presentation and grants nothing. Authorization is always
 * requireOrgRole against the caller's own membership, so opening another
 * partner's hostname shows their logo and none of their data.
 */
export const brandingService = {
	get: (hostname: string = window.location.host, signal?: AbortSignal) =>
		http.get<OrgBranding>("/api/org/branding", { query: { hostname }, signal }),
};
